// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3832r","bigColWidth":"Table_bigColWidth__3Q2LW","biggerColWidth":"Table_biggerColWidth__3oKAd","row":"Table_row__12Oba","col":"Table_col__2zfsa"};